// extracted by mini-css-extract-plugin
module.exports = {"capitalize":"EvolutionCard_capitalize__qTgZP"};